<div class="db-booster-activation-banner">
  <div class="db-booster-activation-banner__text">
    <div class="db-booster-activation-banner__title">
      <img src="assets/images/booster/booster-logo.svg" alt=""/>
      <h1 class="db-booster-activation-banner__title">{{ companyName }} Booster Pro</h1>
    </div>
    <p class="db-booster-activation-banner__item" [innerHTML]="'text_boosterActivationBannerText' | dbText"></p>
  </div>
  <div class="db-booster-activation-banner__button">
    <a class="ds-btn-green ds-btn-m" (click)="getWpImageOptimizerPage()">
      <span [innerHTML]="'text_activateBooster' | dbText"></span>
    </a>
  </div>
</div>
